import { connect } from '@atlassian/jira-react-redux';
import triggerAnalyticsEvent from '@atlassian/jira-servicedesk-automation-common/src/analytics';
import { selectBlueprintAction } from '../../../../../../state/actions/blueprint';
import {
	maybeName,
	maybeDescription,
	isSelected,
} from '../../../../../../state/selectors/blueprint';
import type { State } from '../../../../../../state/types';
import BlueprintOption from './view';

type OwnProps = {
	blueprintModuleKey: string;
};

const mapStateToProps = (state: State, ownProps: OwnProps) => ({
	name: maybeName(state, ownProps.blueprintModuleKey).orSome(''),
	description: maybeDescription(state, ownProps.blueprintModuleKey).orSome(''),
	active: isSelected(state, ownProps.blueprintModuleKey),
});

export default connect(mapStateToProps, {
	// @ts-expect-error - TS7006 - Parameter 'selectedBlueprintKey' implicitly has an 'any' type.
	onSelect: (selectedBlueprintKey) => {
		triggerAnalyticsEvent('summary.blueprint-dialog.blueprint.selected');
		return selectBlueprintAction(selectedBlueprintKey);
	},
})(BlueprintOption);
